import { defineStore } from 'pinia'

export interface TextMessageMetersState {
  firstLineText: string,
  secondLineText: string,
  showMessage: boolean,
}

const initialState = (): TextMessageMetersState => ({
  firstLineText: '',
  secondLineText: '',
  showMessage: false,
})

export const textMessageMetersState = defineStore('textMessageMetersState', {
  state: initialState
})
